export const COMPANY_LOGO_PATH_PREFIX = 'assets/images/companies/';
export const ICONS_PATH_PREFIX = 'assets/images/icons/';
